<template>
  <div
    :class="[colonne.class, 'd-flex no-gutter', 'flex-column']"
    :style="colonne.style ? colonne.style : {}"
    >
    <template v-for="(element, index) in colonne.childElements">
      <text-element
        class="w-100"
        v-if="element.type === 'text'"
        :key="'text-'+index"
        :conIndex="conindex"
        :colIndex="colindex"
        :element="element"
        />
      <bloc-donnees-element
        v-else-if="element.type === 'drop'"
        :key="'bloc-données-'+index"
        :conIndex="conindex"
        :colIndex="colindex"
        :elindex="index"
        :element="element"
      />
      <image-element
        v-else-if="element.type === 'image'"
        :key="'image-'+index"
        :element="element"
      />
      <logo-element
        v-else-if="element.type === 'logo'"
        :key="'logo-'+index"
        :element="element"
      />
    </template>
  </div>
</template>

<script>
import textElement from './textElement'
import blocDonneesElement from './blocDonneesElement'
import {defaultWrapperStyle} from '../../../config/constanteUse'
import imageElement from './imageElement'
import logoElement from './logoElement'
export default {
  components: {
    textElement,
    blocDonneesElement,
    imageElement,
    logoElement
  },
  props: {
    colonne: {
      type: Object,
      required: true
    },
    conindex: Number,
    colindex: Number
  },
  data () {
    return {
      defaultStyle: {...defaultWrapperStyle}
    }
  }
}
</script>

<style>
.no-gutter {
  padding-left: 0;
  padding-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/display/colonne.vue